export const blacklistStatusCode = [404, 401, 422, 400, 405];
